import { render, staticRenderFns } from "./table.vue?vue&type=template&id=1ddb0794&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=1ddb0794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb0794",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ddb0794')) {
      api.createRecord('1ddb0794', component.options)
    } else {
      api.reload('1ddb0794', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=1ddb0794&scoped=true&", function () {
      api.rerender('1ddb0794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mall/views/integral_mall_management/terminal_integral/form/table/table.vue"
export default component.exports